/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { IAppOptions } from "../Components/AppContext/IAppContext";
import { environment } from "../environment";
import StringUtil from "../Utils/StringUtil";

let version = "";

export default async function getLoadPath(): Promise<string> {
    if (StringUtil.isEmpty(version)) {
        version = await fetch(`${environment.sysBaseUrl}/system/ermittleappoptions`).then(async resp => {
            if (resp.ok) {
                return (await resp.json() as IAppOptions).appVersion;
            }

            throw new Error(`Kann App-Version nicht ermitteln: ${resp.status}: ${resp.statusText}`)
        });
    }

    return `/locales/{{lng}}/{{ns}}.json?version=${version}`
}